import { useEffect, useRef, useState } from 'react'

export const useIntersectionObserver = (
  callback: (isIntersecting: boolean) => void,
  isMobile: boolean,
  options: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  }
) => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  const observer = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    if (!element || !isMobile) return

    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        callback(entry.isIntersecting)
      })
    }, options)

    observer.current.observe(element)

    return () => {
      if (observer.current) {
        observer.current.disconnect()
      }
    }
  }, [element, callback, options, isMobile])

  return isMobile ? setElement : undefined
}
